import React from 'react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';

// components
import PickerValues from 'components/Panel/Picker/PickerValues';

// utils
import { getName } from '@sprinklr/display-builder/widgets/utils/getColorTag';
import { uppercaseWithUnderscores } from 'utils/StringUtils/StringUtils';

// types
import { DimensionValuesSelectionProps } from './types';
import { getWidgetDimensionKeyFromAnalyticsGroupBy } from './helpers';

function DimensionValuesSelection({ widget, condition }: DimensionValuesSelectionProps) {
    const engine = widget?.analyticsRequests?.[0]?.reportingEngine;
    const report = widget?.analyticsRequests?.[0]?.report;

    const handleChange = (values: string[]) => {
        const resolvedValues = values?.length > 0 ? values.map(uppercaseWithUnderscores) : values;
        runInAction(() => {
            condition.value = resolvedValues;
        });
    };

    const dimension = widget?.analyticsRequests?.[0]?.groupBys?.find(
        groupBy => getName(groupBy) === condition.name
    );

    if (!dimension || !engine || !report) return null;

    const selectedValues = condition.value ?? [];
    const widgetDimensionKey = getWidgetDimensionKeyFromAnalyticsGroupBy(dimension);

    return (
        <PickerValues
            dimension={widgetDimensionKey}
            engine={engine}
            report={report}
            onChange={handleChange}
            selectedValues={[...selectedValues]}
        />
    );
}

const DimensionValuesSelectionHOC = observer(DimensionValuesSelection);
export { DimensionValuesSelectionHOC as DimensionValuesSelection };
